import { createSlice } from '@reduxjs/toolkit'

export const modalsSlice = createSlice({
  name: 'modals',
  initialState: [],
  reducers: {
    open: (state, { payload }) => {
      const isExist = state.includes(payload)

      if (!isExist) {
        state.push(payload)
      }
    },
    close: (state) => {
      state.pop()
    },
  },
})

export const { open, close } = modalsSlice.actions

export default modalsSlice.reducer
